
import { useRef, useEffect } from 'react';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

interface RefObject {
    current: HTMLCanvasElement | null;
}

interface IChartCompProps {
    data: any | null
}

/**
 * @returns date
 */
const getDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getDate()} ${date.toLocaleString('en-GB', { month: 'long' }).slice(0, 3)}`;
};

const ChartComp = ({ data }: IChartCompProps) => {
  const canvasRef: RefObject = useRef(null);

  useEffect(() => {
    let myChart: Chart;
    if (canvasRef.current && data.length) {
      // Charts
      const ctx = canvasRef.current.getContext('2d');
      if (ctx) {
        canvasRef.current.style.height = '84px';
        const gradient = ctx.createLinearGradient(0, 0, 0, 160);
        gradient.addColorStop(0, 'rgba(57, 83, 249, 0.6)');
        gradient.addColorStop(0.3, 'rgba(57, 83, 249, 0.1)');
        gradient.addColorStop(1, 'transparent');

        myChart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: data.map((i: any) => getDate(i.day)), // remove dates
            datasets: [{
              data: data.map((i: any) => i.reserve_usd),
              borderColor: '#3953F9',
              borderWidth: 2,
              tension: 0.3,
              pointRadius: 10,
              pointBorderColor: 'transparent',
              pointBackgroundColor: 'transparent',
              fill: {
                target: 'origin',
                below: gradient,
                above: gradient,
              },
            }]
          },
          options: {
            plugins: {
              tooltip: {
                displayColors: false
              },
              legend: {
                display: false
              }
            },
            scales: {
              x: {
                grid: {
                  color: '#3A3C41',
                  drawBorder: false,
                  drawOnChartArea: false
                },
                ticks: {
                  maxTicksLimit: 4,
                  maxRotation: 0,
                  font: {
                    size: 10,
                    weight: '600',
                    family: 'Inter',
                    lineHeight: 1.5
                  }
                }
              },
              y: {
                beginAtZero: true,
                grid: {
                  color: '#3A3C41',
                  drawBorder: false,
                  borderDash: [3,3],
                  drawTicks: false
                },
                ticks: {
                  maxTicksLimit: 2,
                  font: {
                    size: 10,
                    weight: '600',
                    family: 'Inter',
                    lineHeight: 1.5,
                  },
                  // Include a dollar sign in the ticks
                  callback: function(value, index, ticks) {
                    if (value > 1_000_000) {
                      return `$${Math.round(Number(value) / 1_000_000)}M`;
                    }
                    if (value > 1000) {
                      return `$${Math.round(Number(value) / 1000)}K`;
                    }
                    return `$${Math.round(Number(value))}`;
                  }
                }
              }
            },
          }
        });
      }
    }

    return () => myChart.destroy();
  }, [data]);

  return <canvas ref={canvasRef} />;
};
export default ChartComp;